import React, { FunctionComponent, useState } from 'react'
import { connect } from 'react-redux'

import { PublicWrapper } from '../components'

import { State } from '../reducers'
import {
  fetchDeleteApi,
  fetchGetApi,
  fetchPostApi,
  fetchPutApi,
} from '../utils/fetchWrapper'

const endpoint = '/insights'

// Placeholder functions for testing
const getAllInsights = async (setResult, setName) => {
  console.log('Fetching all insights...')
  const { ok, bodyParsed, errorParsed } = await fetchGetApi(fetch, endpoint)
  // Make your API call here for getting all insights
  setResult(ok ? JSON.stringify(bodyParsed) : JSON.stringify(errorParsed))
  setName('All Insights')
}

const getOneInsight = async (setResult, setName) => {
  console.log(`Fetching insight with ID`)
  // Make your API call here for getting one insight by ID
  const { ok, bodyParsed, errorParsed } = await fetchGetApi(
    fetch,
    endpoint + '/2'
  )
  // Make your API call here for getting all insights
  setResult(ok ? JSON.stringify(bodyParsed) : JSON.stringify(errorParsed))
  setName('One Insight')
}

const createNewInsight = async (setResult, setName) => {
  console.log('Creating a new insight...')
  // Make your API call here for creating a new insight
  const index = Math.floor(Math.random() * 100)
  const insight = {
    name: `New Insight ${index}`,
    type: 'vertical',
    startDate: '2024-10--01',
    endDate: '2024-10-12',
    fields: 'uniqueClicks,impressions,sales,commission',
    groupBy: 'clickedProducts',
    filters: 'verticalId=5',
    showGraph: true,
    graphType: 'bars',
    graphSelectedField: 'uniqueClicks',
  }
  const { ok, bodyParsed, errorParsed } = await fetchPostApi(
    fetch,
    endpoint,
    insight
  )
  setResult(ok ? JSON.stringify(bodyParsed) : JSON.stringify(errorParsed))
  setName('New Insight')
}

const updateInsight = async (setResult, setName) => {
  console.log('Updating an insight...')
  // Make your API call here for updating an insight
  const id = 2
  const updatedInsight = {
    type: 'vertical',
    period: '2 weeks',
    fields: 'uniqueClicks,impressions,sales,commission,conversionRate',
    order: 'impressions|DESC',
  }

  const { ok, bodyParsed, errorParsed } = await fetchPutApi(
    fetch,
    endpoint + '/' + id,
    updatedInsight
  )
  setResult(ok ? JSON.stringify(bodyParsed) : JSON.stringify(errorParsed))
  setName('Updated Insight')
}

const deleteInsight = async (setResult, setName) => {
  console.log('Deleting an insight...')
  // Make your API call here for deleting an insight
  const id = 1
  const { ok, bodyParsed, errorParsed } = await fetchDeleteApi(
    fetch,
    endpoint + '/' + id
  )
  setResult(ok ? JSON.stringify(bodyParsed) : JSON.stringify(errorParsed))
  setName('Deleted Insight')
}

interface TestingContainerProps {
  // Mapping these placeholder functions to props
  getAllInsights: (
    setResult: (value: ((prevState: string) => string) | string) => void,
    setName: (value: ((prevState: string) => string) | string) => void
  ) => void
  getOneInsight: (
    id: (value: ((prevState: string) => string) | string) => void,
    setName: (value: ((prevState: string) => string) | string) => void
  ) => void
  createNewInsight: (
    setResult: (value: ((prevState: string) => string) | string) => void,
    setName: (value: ((prevState: string) => string) | string) => void
  ) => void
  updateInsight: (
    setResult: (value: ((prevState: string) => string) | string) => void,
    setName: (value: ((prevState: string) => string) | string) => void
  ) => void
  deleteInsight: (
    setResult: (value: ((prevState: string) => string) | string) => void,
    setName: (value: ((prevState: string) => string) | string) => void
  ) => void
}

const TestingContainer: FunctionComponent<TestingContainerProps> = ({
  getAllInsights,
  getOneInsight,
  createNewInsight,
  updateInsight,
  deleteInsight,
}) => {
  const [result, setResult] = useState<string>('')
  const [name, setName] = useState<string>('')

  return (
    <PublicWrapper>
      <div>
        <button
          style={{
            padding: '10px 20px',
            margin: '5px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={() => getAllInsights(setResult, setName)}
        >
          Get All Insights
        </button>
        <button
          style={{
            padding: '10px 20px',
            margin: '5px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={() => getOneInsight(setResult, setName)}
        >
          Get One Insight
        </button>
        <button
          style={{
            padding: '10px 20px',
            margin: '5px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={() => createNewInsight(setResult, setName)}
        >
          Create New Insight
        </button>
        <button
          style={{
            padding: '10px 20px',
            margin: '5px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={() => updateInsight(setResult, setName)}
        >
          Update Insight
        </button>
        <button
          style={{
            padding: '10px 20px',
            margin: '5px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={() => deleteInsight(setResult, setName)}
        >
          Delete Insight
        </button>
      </div>

      <div
        style={{ marginTop: '20px', border: '1px solid #ccc', padding: '10px' }}
      >
        <h3>API Request Result for {name}:</h3>
        <br />
        <div>
          <p>{result}</p>
        </div>
      </div>
    </PublicWrapper>
  )
}

const mapStateToProps = (state: State) => ({
  // Add your state mappings here if needed
})

const mapDispatchToProps = dispatch => ({
  // Mapping the placeholder functions to dispatch
  getAllInsights: (setResult, setName) => getAllInsights(setResult, setName),
  getOneInsight: (setResult, setName) => getOneInsight(setResult, setName),
  createNewInsight: (setResult, setName) =>
    createNewInsight(setResult, setName),
  updateInsight: (setResult, setName) => updateInsight(setResult, setName),
  deleteInsight: (setResult, setName) => deleteInsight(setResult, setName),
})

export default connect(mapStateToProps, mapDispatchToProps)(TestingContainer)
